/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'
import {  Container, Table, Header, Rating, Icon, Loader  } from 'semantic-ui-react'

import MapGL, { Marker, Popup, SVGOverlay, CanvasOverlay, LinearInterpolator, FlyToInterpolator } from 'react-map-gl';

import { MAPBOX_TOKEN } from '../../../config/tokens'


import { isAdmin } from './helpers'


class Users extends Component {

  state = {
    loading: true,

    viewport: {
      bearing: 0,
      // pitch: 50,
      pitch: 0,
      width: 800,
      height: 800,
      latitude: 40,
      longitude: -90,
      zoom: 7,
      center: [40,-90],
    },
    settings: {
      dragPan: true,
      dragRotate: true,
      scrollZoom: true,
      touchZoom: true,
      touchRotate: true,
      keyboard: true,
      doubleClickZoom: true,
      minZoom: 0,
      maxZoom: 20,
      minPitch: 0,
      maxPitch: 85
    },

    visibleSessions: {},

  }

  // create class wide variable
  theMapGeoQuery;

  componentDidMount() {
    // console.log('componentDidMount map')
    window.addEventListener('resize', this._resize);
    this._resize();


    // Set up geofire bullshit
    const { geoFire } = this.props
    const { visibleSessions, viewport } = this.state

    console.log('geofire',geoFire)

    this.theMapGeoQuery = geoFire.query({
      // center: [10.38, 2.41],
      center: [50, -90],
      // center: [viewport.latitude, viewport.longitude],
      radius: 50
    });

    let newVisibleSessions = {}

    this.theMapGeoQuery.on("ready", () => {
      // console.log("GeoQuery has loaded and fired all other events for initial data");
      this.setState({visibleSessions: newVisibleSessions})
    });

    this.theMapGeoQuery.on("key_entered", (key, location, distance) => {
      // console.log(key + " entered query at " + location + " (" + distance + " km from center)");
      newVisibleSessions[key] = {location, distance, _key: key}
    });

    this.theMapGeoQuery.on("key_exited", function(key, location, distance) {
      // console.log(key + " exited query to " + location + " (" + distance + " km from center)");
      delete newVisibleSessions[key]
    });

  }


  componentDidUpdate(prevProps, prevState) {
    const { geoFire } = this.props
    // set user data from firebase
    // console.log('geoFire in component',geoFire)

    const { visibleSessions, viewport } = this.state


    if(this.state.loading) {
      // INITIALIZE CODE!
      this.setState({loading: false})
    }



  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  // Resize if user changes window size

  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  };

  _onViewportChange = viewport => {

    this.theMapGeoQuery.updateCriteria({
      center: [viewport.latitude, viewport.longitude],
      // radius: viewport.zoom * 100
      radius: 600,
    });

    this.setState({
      viewport: {
        ...viewport,
        center: [viewport.latitude, viewport.longitude]
      },
    });
  }


  _renderSessionMarker = (session, index) => {
    // console.log('session',session)
    // console.log('index',index)
    // console.log('session.location[0]',session.location[0])

    // return null


    if(!session.location[0] || !session.location[1]) {
      console.warn('some BS', session)
      return

    }


    return (
      <Marker key={`marker-${index}`}
        longitude={session.location[1]}
        latitude={session.location[0]} >

        <span aria-label='asdf' role='img'>🙂</span>


      </Marker>
    );
  }

// <Button style={{padding: 2, }} circular onClick={() => this._onMarkerClick(session)} >
  render() {

    const { settings, viewport, loading, visibleSessions } = this.state

    // Dont load map until firebase geoFire data is loaded
    if(loading) { return <Loader active /> }

    // console.log('visibleSessions',visibleSessions)
    // console.log('viewport',viewport)

    return (
      <div>
      <MapGL
        ref={el => this.mapGL = el}
        { ...viewport }
        {...settings}
        scrollZoom={true}
        onViewportChange={ this._onViewportChange }
        mapboxApiAccessToken={MAPBOX_TOKEN}

      >

      {
        _.map(visibleSessions, (s,key) => this._renderSessionMarker(s,key) )
      }

      </MapGL>

      <DebugScreen {...this.state} />
      </div>
    );
  }
}

export default compose(
  firebaseConnect([]),
  connect((state) => {
    return ({
      geoFire: state.geoFire,
      auth: state.firebase.auth,
      // firebase: state.firebase,
    })
  })
)(Users)



// ----------------------------
// Components
// ----------------------------

const DebugScreen = ({viewport, visibleSessions}) => {


  // if(mode === 'discover')
    return (
      <div style={{position: 'absolute', bottom: 50, right: 50}}>
        <p>zoom: {viewport.zoom}</p>
        <p>Total Visible Sessions: { _.size(visibleSessions) }</p>
      </div>
    )
  // else
  // return null
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/UsersMap.js